<template>
  <main-content-layout
    :title="$gettext('VIEW_HISTORIC')"
  >
    <q-page-container class="card-container-modal">
      <jt-data-table
        v-if="fields.length"
        :api-mode="false"
        :data="historyDataTable"
        :fields="fields"
        :buttons="historyForm.buttons"
        class="col-12 tw-px-3 history-table"
        style="height: 400px"
        noneselect
      />
    </q-page-container>
  </main-content-layout>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'

import ServiceRequestHistoryUnitController from './ServiceRequestHistoryUnitController'
import { JtCrud, JtDataTable } from 'jtech-webcomps'
import MainContentLayout from '../../Layout/MainContentLayout.vue'
const { page } = JtCrud

@Component({
  name: 'ServiceRequest.registration-information.history',
  components: { page, MainContentLayout, JtDataTable },
  props: {
    consumerUnit: String,
    protocol: String
  }
})
class ServiceRequestHistoryUnit extends Vue {
  serviceRequestHistoryUnitController = ServiceRequestHistoryUnitController.getInstance();

  historyDataTable = []
  historyForm = { columns: [] };

  mounted () {
    this._hiddenRowMouseoverHandler = (event) => {
      const div = event.target && event.target.closest && event.target.closest('.hidden-row > div')
      if (!div) return
      if (div.scrollWidth > div.clientWidth + 1) {
        div.title = div.textContent.trim()
      } else {
        div.removeAttribute('title')
      }
    }
    document.body.addEventListener('mouseover', this._hiddenRowMouseoverHandler)
    this.loadData()
  }

  beforeDestroy () {
    if (this._hiddenRowMouseoverHandler) {
      document.body.removeEventListener('mouseover', this._hiddenRowMouseoverHandler)
      this._hiddenRowMouseoverHandler = null
    }
  }

  async loadData () {
    const historyForm = await this.serviceRequestHistoryUnitController.loadHistoryForm()
    this.historyForm = historyForm
    const { registros } = await this.serviceRequestHistoryUnitController.loadHistoryDataByConsumerUnit(
      this.consumerUnit
    )
    this.historyDataTable = registros
  }

  get fields () {
    return Object.keys(this.historyForm).length ? this.historyForm.columns : []
  }
}
export default ServiceRequestHistoryUnit
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.history-table {
  ::v-deep {
    .jt-crud-container .justify-end  {
      padding: 0%;
      display: none !important;
      border: 1px solid red !important;
    }
    .q-table--col-auto-width {
      display: none !important;
    }
    .hidden-row {
      max-height: 160px;
      overflow-y: auto;

      > div {
        flex: 0 0 20% !important;
        max-width: 20% !important;
        width: 20% !important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        box-sizing: border-box;
        padding-right: 8px;
        cursor: default;
      }
    }
  }
}

</style>
